/*preparing-a-single-package-workspace*/
/*preparing-a-multi-package-workspace-monorepo*/
/*adding-turborepo-to-your-repository*/
/*install-turbo*/
/*add-a-turbojson-file*/
/*edit-gitignore*/
/*add-a-packagemanager-field-to-root-packagejson*/
/*set-up-package-manager-workspaces*/
/*run-tasks-with-turbo*/
/*begin-developing-by-running-dev-with-turbo*/
/*next-steps*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "添加到现有仓库",
  "description": "将 Turborepo 与你现有的仓库结合使用"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 可以逐步采用到任何存储库（单个或多个软件包），以加快存储库的开发者和 CI 工作流程。"
  }, {
    "heading": "",
    "content": "¥Turborepo can be incrementally adopted in any repository, single or multi-package, to speed up the developer and CI workflows of the repository."
  }, {
    "heading": "",
    "content": "安装 turbo 并在 turbo.json 中配置任务后，你会注意到 caching 如何帮助你更快地运行任务。"
  }, {
    "heading": "",
    "content": "¥After installing turbo and configuring your tasks in turbo.json, you'll notice how caching helps you run tasks much faster."
  }, {
    "heading": "准备单包工作区-preparing-a-single-package-workspace",
    "content": "¥Preparing a single-package workspace"
  }, {
    "heading": "准备单包工作区-preparing-a-single-package-workspace",
    "content": "例如，单包工作区 是运行 npx create-next-app 或 npm create vite 后得到的。你无需为 Turborepo 处理你的代码库做任何额外的工作，因此你可以直接跳到下面的第一步。"
  }, {
    "heading": "准备单包工作区-preparing-a-single-package-workspace",
    "content": "¥A single-package workspace is, for example, what you get after running npx create-next-app or npm create vite. You don't need to do any extra work for Turborepo to handle your repo so you can jump to the first step below."
  }, {
    "heading": "准备单包工作区-preparing-a-single-package-workspace",
    "content": "要了解更多关于单包工作区中 Turborepo 的信息，请访问 专用指南。"
  }, {
    "heading": "准备单包工作区-preparing-a-single-package-workspace",
    "content": "¥To learn more about Turborepo in single-package workspaces, visit the dedicated guide."
  }, {
    "heading": "准备多软件包工作区monorepo-preparing-a-multi-package-workspace-monorepo",
    "content": "¥Preparing a multi-package workspace (monorepo)"
  }, {
    "heading": "准备多软件包工作区monorepo-preparing-a-multi-package-workspace-monorepo",
    "content": "turbo 构建于 Workspaces 之上，这是 JavaScript 生态系统中主流包管理器的一项功能。这使得它易于在你现有的代码库中采用。"
  }, {
    "heading": "准备多软件包工作区monorepo-preparing-a-multi-package-workspace-monorepo",
    "content": "¥turbo is built on top of Workspaces, a feature of the major package managers in the JavaScript ecosystem. This makes it easy to adopt in your existing codebase."
  }, {
    "heading": "准备多软件包工作区monorepo-preparing-a-multi-package-workspace-monorepo",
    "content": "如果你发现 turbo 存在问题，例如无法在你的工作区中发现软件包或未遵循依赖图，请访问我们的 构建仓库 页面获取提示。"
  }, {
    "heading": "准备多软件包工作区monorepo-preparing-a-multi-package-workspace-monorepo",
    "content": "¥If you're finding that turbo is having issues like not being able to\ndiscover packages in your workspace or not following your dependency graph,\nvisit our Structuring a\nrepository page for\ntips."
  }, {
    "heading": "准备多软件包工作区monorepo-preparing-a-multi-package-workspace-monorepo",
    "content": "请注意，你不必立即使用 turbo 为所有包运行所有任务。你可以从几个包中的单个任务开始，随着你对 Turborepo 的熟悉程度不断提高，逐步添加更多任务和包。"
  }, {
    "heading": "准备多软件包工作区monorepo-preparing-a-multi-package-workspace-monorepo",
    "content": "¥Note that you don't have to start running all your tasks for all your\npackages using turbo right away. You can start with a single task in just a\nfew packages and incrementally add more tasks and packages as you get more\nfamiliar with Turborepo."
  }, {
    "heading": "将-turborepo-添加到你的仓库-adding-turborepo-to-your-repository",
    "content": "¥Adding Turborepo to your repository"
  }, {
    "heading": "安装-turbo-install-turbo",
    "content": "¥Install turbo"
  }, {
    "heading": "安装-turbo-install-turbo",
    "content": "为了获得最佳的开发者体验，我们建议你全局安装 turbo 并将其安装到你的代码库根目录中。"
  }, {
    "heading": "安装-turbo-install-turbo",
    "content": "¥We recommend you install turbo both globally and into your repository's root for the best developer experience."
  }, {
    "heading": "安装-turbo-install-turbo",
    "content": "在开始安装之前，请确保你已创建 pnpm-workspace.yaml 文件。如果没有此文件，将导致以下错误： --workspace-root may only be used inside a workspace。"
  }, {
    "heading": "安装-turbo-install-turbo",
    "content": "¥Ensure you have created a pnpm-workspace.yaml file before you begin the installation. Failure to have this file will result in an error that says:  --workspace-root may only be used inside a workspace."
  }, {
    "heading": "安装-turbo-install-turbo",
    "content": "要了解更多关于我们推荐这两种安装方式的原因，请访问 安装页面。"
  }, {
    "heading": "安装-turbo-install-turbo",
    "content": "¥To learn more about why we recommend both installations, visit the Installation page."
  }, {
    "heading": "添加-turbojson-文件-add-a-turbojson-file",
    "content": "¥Add a turbo.json file"
  }, {
    "heading": "添加-turbojson-文件-add-a-turbojson-file",
    "content": "在你的代码库根目录中，创建一个 turbo.json 文件。"
  }, {
    "heading": "添加-turbojson-文件-add-a-turbojson-file",
    "content": "¥In the root of your repository, create a turbo.json file."
  }, {
    "heading": "添加-turbojson-文件-add-a-turbojson-file",
    "content": "本指南中我们将使用 build 和 check-types 任务，但你可以将其替换为你感兴趣的其他任务，例如 lint 或 test。"
  }, {
    "heading": "添加-turbojson-文件-add-a-turbojson-file",
    "content": "¥We'll be using build and check-types tasks in this guide but you can replace these with other tasks that interest you, like lint or test."
  }, {
    "heading": "添加-turbojson-文件-add-a-turbojson-file",
    "content": "更多有关配置 turbo.json 的信息，请参阅 配置选项 文档。"
  }, {
    "heading": "添加-turbojson-文件-add-a-turbojson-file",
    "content": "¥For more information on configuring your turbo.json, see the Configuration Options documentation."
  }, {
    "heading": "添加-turbojson-文件-add-a-turbojson-file",
    "content": "在你的 Next.js 应用中，确保你有一个可供 turbo 运行的 check-types 脚本。"
  }, {
    "heading": "添加-turbojson-文件-add-a-turbojson-file",
    "content": "¥In your Next.js application, make sure you have a check-types script for turbo to run."
  }, {
    "heading": "添加-turbojson-文件-add-a-turbojson-file",
    "content": "一些 Vite 启动器附带一个如下所示的 package.json："
  }, {
    "heading": "添加-turbojson-文件-add-a-turbojson-file",
    "content": "¥Some Vite starters ship with a package.json that looks like this:"
  }, {
    "heading": "添加-turbojson-文件-add-a-turbojson-file",
    "content": "我们建议将它们拆分为 check-types 和 build 脚本，以便 turbo 可以并行运行它们。"
  }, {
    "heading": "添加-turbojson-文件-add-a-turbojson-file",
    "content": "¥We recommend splitting these into a check-types and build script so that turbo can run them in parallel."
  }, {
    "heading": "添加-turbojson-文件-add-a-turbojson-file",
    "content": "在多软件包工作区中，你可能还想将 check-types 脚本添加到一个或多个库软件包中，以查看不同软件包中的多个脚本如何使用一个 turbo 命令运行。"
  }, {
    "heading": "添加-turbojson-文件-add-a-turbojson-file",
    "content": "¥In a multi-package workspace, you may also want to add a check-types script\nto one or more of your library packages to see how multiple scripts across\ndifferent packages run with one turbo command."
  }, {
    "heading": "edit-gitignore-edit-gitignore",
    "content": "将 .turbo 添加到你的 .gitignore 文件中。turbo CLI 使用这些文件夹来保存日志、输出和其他功能。"
  }, {
    "heading": "edit-gitignore-edit-gitignore",
    "content": "¥Add .turbo to your .gitignore file. The turbo CLI uses these folders for persisting logs, outputs, and other functionality."
  }, {
    "heading": "将-packagemanager-字段添加到根-packagejson-add-a-packagemanager-field-to-root-packagejson",
    "content": "¥Add a packageManager field to root package.json"
  }, {
    "heading": "将-packagemanager-字段添加到根-packagejson-add-a-packagemanager-field-to-root-packagejson",
    "content": "Turborepo 使用来自包管理器的信息来优化你的代码库。要声明你正在使用的包管理器，请将 packageManager 字段添加到你的根 package.json（如果你还没有）。"
  }, {
    "heading": "将-packagemanager-字段添加到根-packagejson-add-a-packagemanager-field-to-root-packagejson",
    "content": "¥Turborepo optimizes your repository using information from your package manager. To declare which package manager you're using, add a packageManager field to your root package.json if you don't have one already."
  }, {
    "heading": "将-packagemanager-字段添加到根-packagejson-add-a-packagemanager-field-to-root-packagejson",
    "content": "根据你的代码库，你可能需要在迁移期间或尚无法使用 packageManager 密钥的情况下使用 dangerouslyDisablePackageManagerCheck。"
  }, {
    "heading": "将-packagemanager-字段添加到根-packagejson-add-a-packagemanager-field-to-root-packagejson",
    "content": "¥Depending on your repository, you may need to use the\ndangerouslyDisablePackageManagerCheck\nwhile migrating or in situations where you can't use the packageManager key\nyet."
  }, {
    "heading": "设置包管理器工作区-set-up-package-manager-workspaces",
    "content": "¥Set up package manager workspaces"
  }, {
    "heading": "设置包管理器工作区-set-up-package-manager-workspaces",
    "content": "对于 多软件包工作区，你需要配置包管理器以识别你的工作区结构。"
  }, {
    "heading": "设置包管理器工作区-set-up-package-manager-workspaces",
    "content": "¥For multi-package workspaces, you'll need to configure your package manager to recognize your workspace structure."
  }, {
    "heading": "设置包管理器工作区-set-up-package-manager-workspaces",
    "content": "workspaces 字段告诉你的包管理器哪些目录包含你的包。常见的模式包括用于应用的 apps/* 和用于共享库的 packages/*。"
  }, {
    "heading": "设置包管理器工作区-set-up-package-manager-workspaces",
    "content": "¥The workspaces field tells your package manager which directories contain your packages. Common patterns include apps/* for applications and packages/* for shared libraries."
  }, {
    "heading": "设置包管理器工作区-set-up-package-manager-workspaces",
    "content": "如果你使用的是单包存储库，则可以跳过此步骤，因为不需要工作区。"
  }, {
    "heading": "设置包管理器工作区-set-up-package-manager-workspaces",
    "content": "¥If you're working with a single-package repository, you can skip this step as\nworkspaces aren't needed."
  }, {
    "heading": "设置包管理器工作区-set-up-package-manager-workspaces",
    "content": "有关如何构建存储库的更多详细信息，请参阅 构建仓库。"
  }, {
    "heading": "设置包管理器工作区-set-up-package-manager-workspaces",
    "content": "¥For more details on how to structure your repository, see Structuring a Repository."
  }, {
    "heading": "使用-turbo-运行任务-run-tasks-with-turbo",
    "content": "¥Run tasks with turbo"
  }, {
    "heading": "使用-turbo-运行任务-run-tasks-with-turbo",
    "content": "你现在可以使用 Turborepo 运行之前添加到 turbo.json 的任务。使用上面的示例任务："
  }, {
    "heading": "使用-turbo-运行任务-run-tasks-with-turbo",
    "content": "¥You can now run the tasks you added to turbo.json earlier using Turborepo. Using the example tasks from above:"
  }, {
    "heading": "使用-turbo-运行任务-run-tasks-with-turbo",
    "content": "这会同时运行 build 和 check-types 任务。你的 工作区 的依赖图将用于以正确的顺序运行任务。"
  }, {
    "heading": "使用-turbo-运行任务-run-tasks-with-turbo",
    "content": "¥This runs the build and check-types tasks at the same time. The dependency graph of your Workspace will be used to run tasks in the right order."
  }, {
    "heading": "使用-turbo-运行任务-run-tasks-with-turbo",
    "content": "在不对代码进行任何更改的情况下，尝试再次运行 build 和 check-types："
  }, {
    "heading": "使用-turbo-运行任务-run-tasks-with-turbo",
    "content": "¥Without making any changes to the code, try running build and check-types again:"
  }, {
    "heading": "使用-turbo-运行任务-run-tasks-with-turbo",
    "content": "你应该看到如下终端输出："
  }, {
    "heading": "使用-turbo-运行任务-run-tasks-with-turbo",
    "content": "¥You should see terminal output like this:"
  }, {
    "heading": "使用-turbo-运行任务-run-tasks-with-turbo",
    "content": "恭喜！你只需在几毫秒内构建并检查代码即可。"
  }, {
    "heading": "使用-turbo-运行任务-run-tasks-with-turbo",
    "content": "¥Congratulations! You just built and type checked your code in milliseconds."
  }, {
    "heading": "使用-turbo-运行任务-run-tasks-with-turbo",
    "content": "要了解更多关于 turbo 如何实现这一点的信息，请查看 缓存文档。"
  }, {
    "heading": "使用-turbo-运行任务-run-tasks-with-turbo",
    "content": "¥To learn more about how turbo makes this possible, check out the caching documentation."
  }, {
    "heading": "通过运行-dev-和-turbo-开始开发-begin-developing-by-running-dev-with-turbo",
    "content": "¥Begin developing by running dev with turbo"
  }, {
    "heading": "通过运行-dev-和-turbo-开始开发-begin-developing-by-running-dev-with-turbo",
    "content": "在多包工作区中，你可以运行 turbo dev 来同时启动所有包的开发任务。"
  }, {
    "heading": "通过运行-dev-和-turbo-开始开发-begin-developing-by-running-dev-with-turbo",
    "content": "¥In a multi-package workspace, you can run turbo dev to start the development tasks for all your packages at once."
  }, {
    "heading": "通过运行-dev-和-turbo-开始开发-begin-developing-by-running-dev-with-turbo",
    "content": "你还可以使用 使用过滤器 来专注于特定的软件包及其依赖。"
  }, {
    "heading": "通过运行-dev-和-turbo-开始开发-begin-developing-by-running-dev-with-turbo",
    "content": "¥You can also use a filter to focus on a specific package and its dependencies."
  }, {
    "heading": "通过运行-dev-和-turbo-开始开发-begin-developing-by-running-dev-with-turbo",
    "content": "请注意，此步骤在单包工作区中没有太大价值，因为："
  }, {
    "heading": "通过运行-dev-和-turbo-开始开发-begin-developing-by-running-dev-with-turbo",
    "content": "¥Note that this step doesn't provide much value in a single-package workspace since:"
  }, {
    "heading": "通过运行-dev-和-turbo-开始开发-begin-developing-by-running-dev-with-turbo",
    "content": "你无需缓存开发任务的输出。"
  }, {
    "heading": "通过运行-dev-和-turbo-开始开发-begin-developing-by-running-dev-with-turbo",
    "content": "¥You don't cache the outputs for a development task."
  }, {
    "heading": "通过运行-dev-和-turbo-开始开发-begin-developing-by-running-dev-with-turbo",
    "content": "只有一个开发脚本，所以没有可以并行运行的脚本。"
  }, {
    "heading": "通过运行-dev-和-turbo-开始开发-begin-developing-by-running-dev-with-turbo",
    "content": "¥There's only one development script so there's nothing to run in parallel."
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥Next steps"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "你现在已经启动并运行 Turborepo 了！要了解更多改进工作流程和充分利用 turbo 的方法，我们建议你查看以下页面："
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥You're now up and running with Turborepo! To learn about more ways you can improve your workflow and get the most out of turbo, we recommend checking out the following pages:"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "为开发机器启用远程缓存"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥Enabling Remote Caching for development machines"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "在 CI 中启用远程缓存"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥Enabling Remote Caching in CI"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "处理环境变量"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥Handling environment variables"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "过滤任务"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥Filtering tasks"
  }],
  "headings": [{
    "id": "准备单包工作区-preparing-a-single-package-workspace",
    "content": "准备单包工作区 /*preparing-a-single-package-workspace*/"
  }, {
    "id": "准备多软件包工作区monorepo-preparing-a-multi-package-workspace-monorepo",
    "content": "准备多软件包工作区(monorepo) /*preparing-a-multi-package-workspace-monorepo*/"
  }, {
    "id": "将-turborepo-添加到你的仓库-adding-turborepo-to-your-repository",
    "content": "将 Turborepo 添加到你的仓库 /*adding-turborepo-to-your-repository*/"
  }, {
    "id": "安装-turbo-install-turbo",
    "content": "安装 turbo /*install-turbo*/"
  }, {
    "id": "添加-turbojson-文件-add-a-turbojson-file",
    "content": "添加 turbo.json 文件 /*add-a-turbojson-file*/"
  }, {
    "id": "edit-gitignore-edit-gitignore",
    "content": "Edit .gitignore /*edit-gitignore*/"
  }, {
    "id": "将-packagemanager-字段添加到根-packagejson-add-a-packagemanager-field-to-root-packagejson",
    "content": "将 packageManager 字段添加到根 package.json /*add-a-packagemanager-field-to-root-packagejson*/"
  }, {
    "id": "设置包管理器工作区-set-up-package-manager-workspaces",
    "content": "设置包管理器工作区 /*set-up-package-manager-workspaces*/"
  }, {
    "id": "使用-turbo-运行任务-run-tasks-with-turbo",
    "content": "使用 turbo 运行任务 /*run-tasks-with-turbo*/"
  }, {
    "id": "通过运行-dev-和-turbo-开始开发-begin-developing-by-running-dev-with-turbo",
    "content": "通过运行 dev 和 turbo 开始开发 /*begin-developing-by-running-dev-with-turbo*/"
  }, {
    "id": "后续步骤-next-steps",
    "content": "后续步骤 /*next-steps*/"
  }]
};
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
import {Callout} from '#components/callout';
import {Step, Steps} from '#components/steps';
import {LinkToDocumentation} from '#components/link-to-documentation';
export const toc = [{
  depth: 2,
  url: "#准备单包工作区-preparing-a-single-package-workspace",
  title: _jsx(_Fragment, {
    children: "准备单包工作区 "
  })
}, {
  depth: 2,
  url: "#准备多软件包工作区monorepo-preparing-a-multi-package-workspace-monorepo",
  title: _jsx(_Fragment, {
    children: "准备多软件包工作区(monorepo) "
  })
}, {
  depth: 2,
  url: "#将-turborepo-添加到你的仓库-adding-turborepo-to-your-repository",
  title: _jsx(_Fragment, {
    children: "将 Turborepo 添加到你的仓库 "
  })
}, {
  depth: 3,
  url: "#安装-turbo-install-turbo",
  title: _jsxs(_Fragment, {
    children: ["安装 ", _jsx("code", {
      children: "turbo"
    }), " "]
  })
}, {
  depth: 3,
  url: "#添加-turbojson-文件-add-a-turbojson-file",
  title: _jsxs(_Fragment, {
    children: ["添加 ", _jsx("code", {
      children: "turbo.json"
    }), " 文件 "]
  })
}, {
  depth: 3,
  url: "#edit-gitignore-edit-gitignore",
  title: _jsxs(_Fragment, {
    children: ["Edit ", _jsx("code", {
      children: ".gitignore"
    }), " "]
  })
}, {
  depth: 3,
  url: "#将-packagemanager-字段添加到根-packagejson-add-a-packagemanager-field-to-root-packagejson",
  title: _jsxs(_Fragment, {
    children: ["将 ", _jsx("code", {
      children: "packageManager"
    }), " 字段添加到根 ", _jsx("code", {
      children: "package.json"
    }), " "]
  })
}, {
  depth: 3,
  url: "#设置包管理器工作区-set-up-package-manager-workspaces",
  title: _jsx(_Fragment, {
    children: "设置包管理器工作区 "
  })
}, {
  depth: 3,
  url: "#使用-turbo-运行任务-run-tasks-with-turbo",
  title: _jsxs(_Fragment, {
    children: ["使用 ", _jsx("code", {
      children: "turbo"
    }), " 运行任务 "]
  })
}, {
  depth: 3,
  url: "#通过运行-dev-和-turbo-开始开发-begin-developing-by-running-dev-with-turbo",
  title: _jsxs(_Fragment, {
    children: ["通过运行 ", _jsx("code", {
      children: "dev"
    }), " 和 ", _jsx("code", {
      children: "turbo"
    }), " 开始开发 "]
  })
}, {
  depth: 2,
  url: "#后续步骤-next-steps",
  title: _jsx(_Fragment, {
    children: "后续步骤 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Turborepo 可以逐步采用到任何存储库（单个或多个软件包），以加快存储库的开发者和 CI 工作流程。"
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo can be incrementally adopted in ", _jsx(_components.strong, {
        children: "any repository, single or multi-package"
      }), ", to speed up the developer and CI workflows of the repository."]
    }), "\n", _jsxs(_components.p, {
      children: ["安装 ", _jsx(_components.code, {
        children: "turbo"
      }), " 并在 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中配置任务后，你会注意到 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "caching"
      }), " 如何帮助你更快地运行任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥After installing ", _jsx(_components.code, {
        children: "turbo"
      }), " and configuring your tasks in ", _jsx(_components.code, {
        children: "turbo.json"
      }), ", you'll notice how ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "caching"
      }), " helps you run tasks much faster."]
    }), "\n", _jsx(_components.h2, {
      id: "准备单包工作区-preparing-a-single-package-workspace",
      children: "准备单包工作区 "
    }), "\n", _jsx(_components.p, {
      children: "¥Preparing a single-package workspace"
    }), "\n", _jsxs(_components.p, {
      children: ["例如，", _jsx(_components.a, {
        href: "https://vercel.com/docs/vercel-platform/glossary#single-package-workspace",
        children: "单包工作区"
      }), " 是运行 ", _jsx(_components.code, {
        children: "npx create-next-app"
      }), " 或 ", _jsx(_components.code, {
        children: "npm create vite"
      }), " 后得到的。你无需为 Turborepo 处理你的代码库做任何额外的工作，因此你可以直接跳到下面的第一步。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥A ", _jsx(_components.a, {
        href: "https://vercel.com/docs/vercel-platform/glossary#single-package-workspace",
        children: "single-package workspace"
      }), " is, for example, what you get after running ", _jsx(_components.code, {
        children: "npx create-next-app"
      }), " or ", _jsx(_components.code, {
        children: "npm create vite"
      }), ". You don't need to do any extra work for Turborepo to handle your repo so you can jump to the first step below."]
    }), "\n", _jsxs(_components.p, {
      children: ["要了解更多关于单包工作区中 Turborepo 的信息，请访问 ", _jsx(_components.a, {
        href: "/docs/guides/single-package-workspaces",
        children: "专用指南"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To learn more about Turborepo in single-package workspaces, visit ", _jsx(_components.a, {
        href: "/docs/guides/single-package-workspaces",
        children: "the dedicated guide"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "准备多软件包工作区monorepo-preparing-a-multi-package-workspace-monorepo",
      children: "准备多软件包工作区(monorepo) "
    }), "\n", _jsx(_components.p, {
      children: "¥Preparing a multi-package workspace (monorepo)"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), " 构建于 Workspaces 之上，这是 JavaScript 生态系统中主流包管理器的一项功能。这使得它易于在你现有的代码库中采用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "turbo"
      }), " is built on top of Workspaces, a feature of the major package managers in the JavaScript ecosystem. This makes it easy to adopt in your existing codebase."]
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsxs(_components.p, {
        children: ["如果你发现 ", _jsx(_components.code, {
          children: "turbo"
        }), " 存在问题，例如无法在你的工作区中发现软件包或未遵循依赖图，请访问我们的 ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/structuring-a-repository",
          children: "构建仓库"
        }), " 页面获取提示。"]
      }), _jsxs(_components.p, {
        children: ["¥If you're finding that ", _jsx(_components.code, {
          children: "turbo"
        }), " is having issues like not being able to\ndiscover packages in your workspace or not following your dependency graph,\nvisit our ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/structuring-a-repository",
          children: "Structuring a\nrepository"
        }), " page for\ntips."]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["请注意，你不必立即使用 ", _jsx(_components.code, {
        children: "turbo"
      }), " 为所有包运行所有任务。你可以从几个包中的单个任务开始，随着你对 Turborepo 的熟悉程度不断提高，逐步添加更多任务和包。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Note that you don't have to start running ", _jsx(_components.em, {
        children: "all"
      }), " your tasks for ", _jsx(_components.em, {
        children: "all"
      }), " your\npackages using ", _jsx(_components.code, {
        children: "turbo"
      }), " right away. You can start with a single task in just a\nfew packages and incrementally add more tasks and packages as you get more\nfamiliar with Turborepo."]
    }), "\n", _jsx(_components.h2, {
      id: "将-turborepo-添加到你的仓库-adding-turborepo-to-your-repository",
      children: "将 Turborepo 添加到你的仓库 "
    }), "\n", _jsx(_components.p, {
      children: "¥Adding Turborepo to your repository"
    }), "\n", _jsxs(Steps, {
      children: [_jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "安装-turbo-install-turbo",
          children: ["安装 ", _jsx(_components.code, {
            children: "turbo"
          }), " "]
        }), _jsxs(_components.p, {
          children: ["¥Install ", _jsx(_components.code, {
            children: "turbo"
          })]
        }), _jsxs(_components.p, {
          children: ["为了获得最佳的开发者体验，我们建议你全局安装 ", _jsx(_components.code, {
            children: "turbo"
          }), " 并将其安装到你的代码库根目录中。"]
        }), _jsxs(_components.p, {
          children: ["¥We recommend you install ", _jsx(_components.code, {
            children: "turbo"
          }), " both globally and into your repository's root for the best developer experience."]
        }), _jsxs(Tabs, {
          groupId: "package-manager",
          items: ['pnpm', 'yarn', 'npm', 'bun'],
          persist: true,
          children: [_jsxs(Tab, {
            value: "pnpm",
            children: [_jsxs(_components.p, {
              children: ["在开始安装之前，请确保你已创建 ", _jsx(_components.code, {
                children: "pnpm-workspace.yaml"
              }), " 文件。如果没有此文件，将导致以下错误：", _jsx(_components.code, {
                children: " --workspace-root may only be used inside a workspace"
              }), "。"]
            }), _jsxs(_components.p, {
              children: ["¥Ensure you have created a ", _jsx(_components.code, {
                children: "pnpm-workspace.yaml"
              }), " file before you begin the installation. Failure to have this file will result in an error that says: ", _jsx(_components.code, {
                children: " --workspace-root may only be used inside a workspace"
              }), "."]
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-comment)",
                        "--shiki-dark": "var(--shiki-token-comment)"
                      },
                      children: "# Global install"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "pnpm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --global"
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-comment)",
                        "--shiki-dark": "var(--shiki-token-comment)"
                      },
                      children: "# Install in repository"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "pnpm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --save-dev"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --workspace-root"
                    })]
                  })]
                })
              })
            })]
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-comment)",
                        "--shiki-dark": "var(--shiki-token-comment)"
                      },
                      children: "# Global install"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " global"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo"
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-comment)",
                        "--shiki-dark": "var(--shiki-token-comment)"
                      },
                      children: "# Install in repository"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --dev"
                    })]
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-comment)",
                        "--shiki-dark": "var(--shiki-token-comment)"
                      },
                      children: "# Global install"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " install"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --global"
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-comment)",
                        "--shiki-dark": "var(--shiki-token-comment)"
                      },
                      children: "# Install in repository"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " install"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --save-dev"
                    })]
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-comment)",
                        "--shiki-dark": "var(--shiki-token-comment)"
                      },
                      children: "# Global install"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "bun"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " install"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --global"
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-comment)",
                        "--shiki-dark": "var(--shiki-token-comment)"
                      },
                      children: "# Install in repository"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "bun"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " install"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --dev"
                    })]
                  })]
                })
              })
            })
          })]
        }), _jsxs(_components.p, {
          children: ["要了解更多关于我们推荐这两种安装方式的原因，请访问 ", _jsx(_components.a, {
            href: "/docs/getting-started/installation",
            children: "安装页面"
          }), "。"]
        }), _jsxs(_components.p, {
          children: ["¥To learn more about why we recommend both installations, visit the ", _jsx(_components.a, {
            href: "/docs/getting-started/installation",
            children: "Installation page"
          }), "."]
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "添加-turbojson-文件-add-a-turbojson-file",
          children: ["添加 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 文件 "]
        }), _jsxs(_components.p, {
          children: ["¥Add a ", _jsx(_components.code, {
            children: "turbo.json"
          }), " file"]
        }), _jsxs(_components.p, {
          children: ["在你的代码库根目录中，创建一个 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 文件。"]
        }), _jsxs(_components.p, {
          children: ["¥In the root of your repository, create a ", _jsx(_components.code, {
            children: "turbo.json"
          }), " file."]
        }), _jsxs(_components.p, {
          children: ["本指南中我们将使用 ", _jsx(_components.code, {
            children: "build"
          }), " 和 ", _jsx(_components.code, {
            children: "check-types"
          }), " 任务，但你可以将其替换为你感兴趣的其他任务，例如 ", _jsx(_components.code, {
            children: "lint"
          }), " 或 ", _jsx(_components.code, {
            children: "test"
          }), "。"]
        }), _jsxs(_components.p, {
          children: ["¥We'll be using ", _jsx(_components.code, {
            children: "build"
          }), " and ", _jsx(_components.code, {
            children: "check-types"
          }), " tasks in this guide but you can replace these with other tasks that interest you, like ", _jsx(_components.code, {
            children: "lint"
          }), " or ", _jsx(_components.code, {
            children: "test"
          }), "."]
        }), _jsxs(Tabs, {
          items: ['Next.js', 'Vite'],
          storageKey: "framework-preference",
          children: [_jsxs(Tab, {
            value: "Next.js",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./turbo.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"$schema\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"https://turbo.nodejs.cn/schema.json\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"tasks\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"build\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"dependsOn\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"^build\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "]"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"outputs\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\".next/**\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"!.next/cache/**\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "]"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"check-types\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"dependsOn\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"^check-types\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "]"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"dev\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"persistent\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-constant)",
                        "--shiki-dark": "var(--shiki-token-constant)"
                      },
                      children: " true"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"cache\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-constant)",
                        "--shiki-dark": "var(--shiki-token-constant)"
                      },
                      children: " false"
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            }), _jsxs(_components.p, {
              children: ["更多有关配置 ", _jsx(_components.code, {
                children: "turbo.json"
              }), " 的信息，请参阅 ", _jsx(_components.a, {
                href: "/docs/reference/configuration",
                children: "配置选项"
              }), " 文档。"]
            }), _jsxs(_components.p, {
              children: ["¥For more information on configuring your ", _jsx(_components.code, {
                children: "turbo.json"
              }), ", see the ", _jsx(_components.a, {
                href: "/docs/reference/configuration",
                children: "Configuration Options"
              }), " documentation."]
            }), _jsxs(_components.p, {
              children: ["在你的 Next.js 应用中，确保你有一个可供 ", _jsx(_components.code, {
                children: "turbo"
              }), " 运行的 ", _jsx(_components.code, {
                children: "check-types"
              }), " 脚本。"]
            }), _jsxs(_components.p, {
              children: ["¥In your Next.js application, make sure you have a ", _jsx(_components.code, {
                children: "check-types"
              }), " script for ", _jsx(_components.code, {
                children: "turbo"
              }), " to run."]
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "apps/web/package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  \"scripts\": {"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+   \"check-types\": \"tsc --noEmit\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })]
          }), _jsxs(Tab, {
            value: "Vite",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./turbo.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"$schema\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"https://turbo.nodejs.cn/schema.json\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"tasks\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"build\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"outputs\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"dist/**\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "]"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"check-types\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"dependsOn\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"^check-types\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "]"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"dev\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"persistent\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-constant)",
                        "--shiki-dark": "var(--shiki-token-constant)"
                      },
                      children: " true"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"cache\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-constant)",
                        "--shiki-dark": "var(--shiki-token-constant)"
                      },
                      children: " false"
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            }), _jsxs(_components.p, {
              children: ["一些 Vite 启动器附带一个如下所示的 ", _jsx(_components.code, {
                children: "package.json"
              }), "："]
            }), _jsxs(_components.p, {
              children: ["¥Some Vite starters ship with a ", _jsx(_components.code, {
                children: "package.json"
              }), " that looks like this:"]
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"scripts\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"build\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"tsc && vite build\""
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            }), _jsxs(_components.p, {
              children: ["我们建议将它们拆分为 ", _jsx(_components.code, {
                children: "check-types"
              }), " 和 ", _jsx(_components.code, {
                children: "build"
              }), " 脚本，以便 ", _jsx(_components.code, {
                children: "turbo"
              }), " 可以并行运行它们。"]
            }), _jsxs(_components.p, {
              children: ["¥We recommend splitting these into a ", _jsx(_components.code, {
                children: "check-types"
              }), " and ", _jsx(_components.code, {
                children: "build"
              }), " script so that ", _jsx(_components.code, {
                children: "turbo"
              }), " can run them in parallel."]
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "apps/web/package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"scripts\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"build\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"vite build\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"check-types\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"tsc --noEmit\""
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })]
          })]
        }), _jsxs(_components.p, {
          children: ["在多软件包工作区中，你可能还想将 ", _jsx(_components.code, {
            children: "check-types"
          }), " 脚本添加到一个或多个库软件包中，以查看不同软件包中的多个脚本如何使用一个 ", _jsx(_components.code, {
            children: "turbo"
          }), " 命令运行。"]
        }), _jsxs(_components.p, {
          children: ["¥In a multi-package workspace, you may also want to add a ", _jsx(_components.code, {
            children: "check-types"
          }), " script\nto one or more of your library packages to see how multiple scripts across\ndifferent packages run with one ", _jsx(_components.code, {
            children: "turbo"
          }), " command."]
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "edit-gitignore-edit-gitignore",
          children: ["Edit ", _jsx(_components.code, {
            children: ".gitignore"
          }), " "]
        }), _jsxs(_components.p, {
          children: ["将 ", _jsx(_components.code, {
            children: ".turbo"
          }), " 添加到你的 ", _jsx(_components.code, {
            children: ".gitignore"
          }), " 文件中。", _jsx(_components.code, {
            children: "turbo"
          }), " CLI 使用这些文件夹来保存日志、输出和其他功能。"]
        }), _jsxs(_components.p, {
          children: ["¥Add ", _jsx(_components.code, {
            children: ".turbo"
          }), " to your ", _jsx(_components.code, {
            children: ".gitignore"
          }), " file. The ", _jsx(_components.code, {
            children: "turbo"
          }), " CLI uses these folders for persisting logs, outputs, and other functionality."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: ".gitignore",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+ .turbo"
                })
              })
            })
          })
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "将-packagemanager-字段添加到根-packagejson-add-a-packagemanager-field-to-root-packagejson",
          children: ["将 ", _jsx(_components.code, {
            children: "packageManager"
          }), " 字段添加到根 ", _jsx(_components.code, {
            children: "package.json"
          }), " "]
        }), _jsxs(_components.p, {
          children: ["¥Add a ", _jsx(_components.code, {
            children: "packageManager"
          }), " field to root ", _jsx(_components.code, {
            children: "package.json"
          })]
        }), _jsxs(_components.p, {
          children: ["Turborepo 使用来自包管理器的信息来优化你的代码库。要声明你正在使用的包管理器，请将 ", _jsx(_components.a, {
            href: "https://nodejs.cn/api/packages.html#packagemanager",
            children: _jsx(_components.code, {
              children: "packageManager"
            })
          }), " 字段添加到你的根 ", _jsx(_components.code, {
            children: "package.json"
          }), "（如果你还没有）。"]
        }), _jsxs(_components.p, {
          children: ["¥Turborepo optimizes your repository using information from your package manager. To declare which package manager you're using, add a ", _jsx(_components.a, {
            href: "https://nodejs.cn/api/packages.html#packagemanager",
            children: _jsx(_components.code, {
              children: "packageManager"
            })
          }), " field to your root ", _jsx(_components.code, {
            children: "package.json"
          }), " if you don't have one already."]
        }), _jsxs(Tabs, {
          groupId: "package-manager",
          items: ['pnpm', 'yarn', 'npm', 'bun'],
          persist: true,
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+  \"packageManager\": \"pnpm@10.0.0\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+  \"packageManager\": \"yarn@1.22.19\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+  \"packageManager\": \"npm@8.5.0\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+  \"packageManager\": \"bun@1.2.0\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          })]
        }), _jsxs(Callout, {
          type: "good-to-know",
          children: [_jsxs(_components.p, {
            children: ["根据你的代码库，你可能需要在迁移期间或尚无法使用 ", _jsx(_components.code, {
              children: "packageManager"
            }), " 密钥的情况下使用 ", _jsx(_components.a, {
              href: "/docs/reference/configuration#dangerouslydisablepackagemanagercheck",
              children: _jsx(_components.code, {
                children: "dangerouslyDisablePackageManagerCheck"
              })
            }), "。"]
          }), _jsxs(_components.p, {
            children: ["¥Depending on your repository, you may need to use the\n", _jsx(_components.a, {
              href: "/docs/reference/configuration#dangerouslydisablepackagemanagercheck",
              children: _jsx(_components.code, {
                children: "dangerouslyDisablePackageManagerCheck"
              })
            }), "\nwhile migrating or in situations where you can't use the ", _jsx(_components.code, {
              children: "packageManager"
            }), " key\nyet."]
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "设置包管理器工作区-set-up-package-manager-workspaces",
          children: "设置包管理器工作区 "
        }), _jsx(_components.p, {
          children: "¥Set up package manager workspaces"
        }), _jsxs(_components.p, {
          children: ["对于 ", _jsx(_components.a, {
            href: "https://vercel.com/docs/glossary#multi-package-workspace",
            children: "多软件包工作区"
          }), "，你需要配置包管理器以识别你的工作区结构。"]
        }), _jsxs(_components.p, {
          children: ["¥For ", _jsx(_components.a, {
            href: "https://vercel.com/docs/glossary#multi-package-workspace",
            children: "multi-package workspaces"
          }), ", you'll need to configure your package manager to recognize your workspace structure."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "workspaces"
          }), " 字段告诉你的包管理器哪些目录包含你的包。常见的模式包括用于应用的 ", _jsx(_components.code, {
            children: "apps/*"
          }), " 和用于共享库的 ", _jsx(_components.code, {
            children: "packages/*"
          }), "。"]
        }), _jsxs(_components.p, {
          children: ["¥The ", _jsx(_components.code, {
            children: "workspaces"
          }), " field tells your package manager which directories contain your packages. Common patterns include ", _jsx(_components.code, {
            children: "apps/*"
          }), " for applications and ", _jsx(_components.code, {
            children: "packages/*"
          }), " for shared libraries."]
        }), _jsxs(Callout, {
          type: "good-to-know",
          children: [_jsx(_components.p, {
            children: "如果你使用的是单包存储库，则可以跳过此步骤，因为不需要工作区。"
          }), _jsx(_components.p, {
            children: "¥If you're working with a single-package repository, you can skip this step as\nworkspaces aren't needed."
          })]
        }), _jsxs(Tabs, {
          groupId: "package-manager",
          items: ['pnpm', 'yarn', 'npm', 'bun'],
          persist: true,
          children: [_jsxs(Tab, {
            value: "pnpm",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "pnpm-workspace.yaml",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "packages:"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  - "
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"apps/*\""
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  - "
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"packages/*\""
                    })]
                  })]
                })
              })
            }), _jsx(LinkToDocumentation, {
              href: "https://pnpm.nodejs.cn/pnpm-workspace_yaml",
              children: "pnpm workspace documentation"
            })]
          }), _jsxs(Tab, {
            value: "yarn",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"workspaces\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"apps/*\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"packages/*\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  ]"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            }), _jsx(LinkToDocumentation, {
              href: "https://yarn.nodejs.cn/features/workspaces#how-are-workspaces-declared",
              children: "yarn workspace documentation"
            })]
          }), _jsxs(Tab, {
            value: "npm",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"workspaces\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"apps/*\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"packages/*\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  ]"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            }), _jsx(LinkToDocumentation, {
              href: "https://npm.nodejs.cn/cli/v7/using-npm/workspaces#defining-workspaces",
              children: "npm workspace documentation"
            })]
          }), _jsxs(Tab, {
            value: "bun",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"workspaces\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"apps/*\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"packages/*\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  ]"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            }), _jsx(LinkToDocumentation, {
              href: "https://bun.sh/docs/install/workspaces",
              children: "bun workspace documentation"
            })]
          })]
        }), _jsxs(_components.p, {
          children: ["有关如何构建存储库的更多详细信息，请参阅 ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/structuring-a-repository#declaring-directories-for-packages",
            children: "构建仓库"
          }), "。"]
        }), _jsxs(_components.p, {
          children: ["¥For more details on how to structure your repository, see ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/structuring-a-repository#declaring-directories-for-packages",
            children: "Structuring a Repository"
          }), "."]
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "使用-turbo-运行任务-run-tasks-with-turbo",
          children: ["使用 ", _jsx(_components.code, {
            children: "turbo"
          }), " 运行任务 "]
        }), _jsxs(_components.p, {
          children: ["¥Run tasks with ", _jsx(_components.code, {
            children: "turbo"
          })]
        }), _jsxs(_components.p, {
          children: ["你现在可以使用 Turborepo 运行之前添加到 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 的任务。使用上面的示例任务："]
        }), _jsxs(_components.p, {
          children: ["¥You can now run the tasks you added to ", _jsx(_components.code, {
            children: "turbo.json"
          }), " earlier using Turborepo. Using the example tasks from above:"]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " build"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " check-types"
                })]
              })
            })
          })
        }), _jsxs(_components.p, {
          children: ["这会同时运行 ", _jsx(_components.code, {
            children: "build"
          }), " 和 ", _jsx(_components.code, {
            children: "check-types"
          }), " 任务。你的 ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/structuring-a-repository#anatomy-of-a-workspace",
            children: "工作区"
          }), " 的依赖图将用于以正确的顺序运行任务。"]
        }), _jsxs(_components.p, {
          children: ["¥This runs the ", _jsx(_components.code, {
            children: "build"
          }), " and ", _jsx(_components.code, {
            children: "check-types"
          }), " tasks at the same time. The dependency graph of your ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/structuring-a-repository#anatomy-of-a-workspace",
            children: "Workspace"
          }), " will be used to run tasks in the right order."]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.p, {
          children: _jsxs(_components.strong, {
            children: ["在不对代码进行任何更改的情况下，尝试再次运行 ", _jsx(_components.code, {
              children: "build"
            }), " 和 ", _jsx(_components.code, {
              children: "check-types"
            }), "："]
          })
        }), _jsxs(_components.p, {
          children: ["¥", _jsxs(_components.strong, {
            children: ["Without making any changes to the code, try running ", _jsx(_components.code, {
              children: "build"
            }), " and ", _jsx(_components.code, {
              children: "check-types"
            }), " again:"]
          })]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " check-types"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " build"
                })]
              })
            })
          })
        }), _jsx(_components.p, {
          children: "你应该看到如下终端输出："
        }), _jsx(_components.p, {
          children: "¥You should see terminal output like this:"
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "Tasks:"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: "    2"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " successful,"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " 2"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " total"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "Cached:"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: "    2"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " cached,"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " 2"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " total"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "Time:"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: "    185ms"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " >>> "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: "FULL"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " TURBO"
                })]
              })]
            })
          })
        }), _jsx(_components.p, {
          children: "恭喜！你只需在几毫秒内构建并检查代码即可。"
        }), _jsxs(_components.p, {
          children: ["¥Congratulations! ", _jsx(_components.strong, {
            children: "You just built and type checked your code in milliseconds"
          }), "."]
        }), _jsxs(_components.p, {
          children: ["要了解更多关于 ", _jsx(_components.code, {
            children: "turbo"
          }), " 如何实现这一点的信息，请查看 ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/caching",
            children: "缓存文档"
          }), "。"]
        }), _jsxs(_components.p, {
          children: ["¥To learn more about how ", _jsx(_components.code, {
            children: "turbo"
          }), " makes this possible, check out ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/caching",
            children: "the caching documentation"
          }), "."]
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "通过运行-dev-和-turbo-开始开发-begin-developing-by-running-dev-with-turbo",
          children: ["通过运行 ", _jsx(_components.code, {
            children: "dev"
          }), " 和 ", _jsx(_components.code, {
            children: "turbo"
          }), " 开始开发 "]
        }), _jsxs(_components.p, {
          children: ["¥Begin developing by running ", _jsx(_components.code, {
            children: "dev"
          }), " with ", _jsx(_components.code, {
            children: "turbo"
          })]
        }), _jsxs(_components.p, {
          children: ["在多包工作区中，你可以运行 ", _jsx(_components.code, {
            children: "turbo dev"
          }), " 来同时启动所有包的开发任务。"]
        }), _jsxs(_components.p, {
          children: ["¥In a multi-package workspace, you can run ", _jsx(_components.code, {
            children: "turbo dev"
          }), " to start the development tasks for all your packages at once."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dev"
                })]
              })
            })
          })
        }), _jsxs(_components.p, {
          children: ["你还可以使用 ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/running-tasks#using-filters",
            children: "使用过滤器"
          }), " 来专注于特定的软件包及其依赖。"]
        }), _jsxs(_components.p, {
          children: ["¥You can also ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/running-tasks#using-filters",
            children: "use a filter"
          }), " to focus on a specific package and its dependencies."]
        }), _jsxs(Callout, {
          type: "info",
          children: [_jsx(_components.p, {
            children: "请注意，此步骤在单包工作区中没有太大价值，因为："
          }), _jsx(_components.p, {
            children: "¥Note that this step doesn't provide much value in a single-package workspace since:"
          }), _jsxs(_components.ul, {
            children: ["\n", _jsxs(_components.li, {
              children: ["\n", _jsx(_components.p, {
                children: "你无需缓存开发任务的输出。"
              }), "\n", _jsx(_components.p, {
                children: "¥You don't cache the outputs for a development task."
              }), "\n"]
            }), "\n", _jsxs(_components.li, {
              children: ["\n", _jsx(_components.p, {
                children: "只有一个开发脚本，所以没有可以并行运行的脚本。"
              }), "\n", _jsx(_components.p, {
                children: "¥There's only one development script so there's nothing to run in parallel."
              }), "\n"]
            }), "\n"]
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h2, {
          id: "后续步骤-next-steps",
          children: "后续步骤 "
        }), _jsx(_components.p, {
          children: "¥Next steps"
        }), _jsxs(_components.p, {
          children: ["你现在已经启动并运行 Turborepo 了！要了解更多改进工作流程和充分利用 ", _jsx(_components.code, {
            children: "turbo"
          }), " 的方法，我们建议你查看以下页面："]
        }), _jsxs(_components.p, {
          children: ["¥You're now up and running with Turborepo! To learn about more ways you can improve your workflow and get the most out of ", _jsx(_components.code, {
            children: "turbo"
          }), ", we recommend checking out the following pages:"]
        }), _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["\n", _jsx(_components.p, {
              children: _jsx(_components.a, {
                href: "/docs/crafting-your-repository/constructing-ci#enabling-remote-caching",
                children: "为开发机器启用远程缓存"
              })
            }), "\n", _jsxs(_components.p, {
              children: ["¥", _jsx(_components.a, {
                href: "/docs/crafting-your-repository/constructing-ci#enabling-remote-caching",
                children: "Enabling Remote Caching for development machines"
              })]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsx(_components.p, {
              children: _jsx(_components.a, {
                href: "/docs/crafting-your-repository/constructing-ci",
                children: "在 CI 中启用远程缓存"
              })
            }), "\n", _jsxs(_components.p, {
              children: ["¥", _jsx(_components.a, {
                href: "/docs/crafting-your-repository/constructing-ci",
                children: "Enabling Remote Caching in CI"
              })]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsx(_components.p, {
              children: _jsx(_components.a, {
                href: "/docs/crafting-your-repository/using-environment-variables",
                children: "处理环境变量"
              })
            }), "\n", _jsxs(_components.p, {
              children: ["¥", _jsx(_components.a, {
                href: "/docs/crafting-your-repository/using-environment-variables",
                children: "Handling environment variables"
              })]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsx(_components.p, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--filter-string",
                children: "过滤任务"
              })
            }), "\n", _jsxs(_components.p, {
              children: ["¥", _jsx(_components.a, {
                href: "/docs/reference/run#--filter-string",
                children: "Filtering tasks"
              })]
            }), "\n"]
          }), "\n"]
        })]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
